import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import setAuthToken from './utils/setAuthToken';
import jwt_decode from 'jwt-decode';

import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';

import store from './store';

import PrivateRoute from './components/common/PrivateRoute';

//Profiles
import Home from './components/layout/Home';
import TranslationsMain from './components/translations/TranslationsMain';
import Login from './components/auth/Login';
import CreateProfile from './components/create-profile/CreateProfile';

//形象
import Corporate from './components/layout/Corporate';
import VideoMainView from './components/video/VideoMainView';
import StylePage from './components/Style/StylePage';
import ClientPage from './components/Client/ClientPage';
import LanguagePage from './components/Language/LanguagePage';

import { setCurrentUser, logoutUser } from './actions/authActions';
import SubtitleContextProvider from './contexts/SubtitleContext';

// import HomePage from './components/homepage/HomePage';
// import AboutPage from "./components/homepage/about/AboutPage";
// import ServicesPage from "./components/homepage/services/ServicesPage";
// import ContactusPage from "./components/homepage/contactus/ContactusPage";

import HomePage_new from './components/homepage_new/HomePage_new';
import AboutPage_new from './components/homepage_new/about/AboutPage';
import ServicesPage_new from './components/homepage_new/services/ServicesPage';
import ContactusPage_new from './components/homepage_new/contactus/ContactusPage';
import WorkPage from './components/homepage_new/work/WorkPage';
import EventPage from './components/homepage_new/event/EventPage';
import VideoTool from './components/videotool/VideoTool';

// 本地儲存驗證 Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // Check for expired .token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
  }
}

//本機預設 findFrameSplitValue
if (!localStorage.findFrameSplitValue) {
  // Set auth token header auth
  // setFrameSplitValue(2);
  //儲存
  localStorage.setItem('findFrameSplitValue', 2);
}

//本機預設 Play/Pause & PlayFromSelectedRow
if (!localStorage.PlayPauseHoykey) {
  // Set auth token header auth
  // setFrameSplitValue(2);
  //儲存
  localStorage.setItem('PlayPauseHoykey', 1);
  localStorage.setItem('PlayFromSelectedRow', 1);
}
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userLanguage: '',
    };
  }

  async componentDidMount() {}

  render() {
    return (
      <React.StrictMode>
        <Provider store={store}>
          <ToastProvider>
            <Router basename={'/dev'}>
              <SubtitleContextProvider>
                <div
                  className='App col-12 px-0 '
                  data-test='component-app'
                  style={{
                    overflowX: 'hidden',
                    backgroundColor: '#000000',
                    height: `${window.innerHeight}px`,
                    width: `${window.innerWidth}px`,
                  }}
                >
                  <Route path='/editor' exact component={Login} />
                  <Route path='/Corporate' exact component={Corporate} />
                  <Route path='/video' exact component={VideoMainView} />

                  {/* <Route path="/" exact component={HomePage} />
                            <Route path="/aboutpage" exact component={AboutPage} />
                            <Route path="/services" exact component={ServicesPage} />
                            <Route path="/contactus" exact component={ContactusPage} /> */}

                  {/* <Route path='/' exact component={HomePage_new} /> */}
                  <Route path='/aboutpage' exact component={AboutPage_new} />
                  <Route path='/services' exact component={ServicesPage_new} />
                  <Route path='/work' exact component={WorkPage} />
                  <Route path='/event' exact component={EventPage} />
                  <Route path='/videotool' exact component={VideoTool} />

                  
                  <Route
                    path='/contactus'
                    exact
                    component={ContactusPage_new}
                  />

                  {/*<Route path="/Home" exact component={Home} />*/}
                  {/*<Route path="/translations/:tType/:tID" exact component={TranslationsView} />*/}
                  {/*<Route path="/importview" exact component={ImportView} />*/}

                  <Switch>
                    <PrivateRoute
                      exact
                      path='/create-profile'
                      component={CreateProfile}
                    />

                    <PrivateRoute exact path='/style' component={StylePage} />
                    <PrivateRoute exact path='/client' component={ClientPage} />
                    <PrivateRoute
                      exact
                      path='/language'
                      component={LanguagePage}
                    />

                    <PrivateRoute exact path='/Home' component={Home} />

                    <PrivateRoute
                      exact
                      path='/translations/:tType/:tIndex'
                      component={TranslationsMain}
                    />
                    <PrivateRoute
                      exact
                      path='/translations/:tType/:tIndex/:stepIndex'
                      component={TranslationsMain}
                    />
                  </Switch>
                </div>
              </SubtitleContextProvider>
            </Router>
          </ToastProvider>
        </Provider>
      </React.StrictMode>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js